module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-searchbox-codpos"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-md-6"
  }, [_c('hrms-lov', {
    attrs: {
      "lovType": "codpos",
      "disabled": false,
      "nowLang": _vm.nowLang,
      "name": "codpos1"
    },
    model: {
      value: (_vm.codpos1),
      callback: function($$v) {
        _vm.codpos1 = $$v
      },
      expression: "codpos1"
    }
  }), _vm._v(" "), _c('hrms-lov', {
    attrs: {
      "lovType": "codpos",
      "disabled": true,
      "nowLang": _vm.nowLang,
      "name": "codpos2"
    },
    model: {
      value: (_vm.codpos2),
      callback: function($$v) {
        _vm.codpos2 = $$v
      },
      expression: "codpos2"
    }
  }), _vm._v(" "), _c('hrms-lov', {
    attrs: {
      "lovType": "codpos",
      "disabled": false,
      "nowLang": _vm.nowLang,
      "name": "codpos2"
    },
    model: {
      value: (_vm.codpos3),
      callback: function($$v) {
        _vm.codpos3 = $$v
      },
      expression: "codpos3"
    }
  })], 1)]), _vm._v(" "), _c('hrms-search-box', {
    attrs: {
      "receivedStore": _vm.receivedStore,
      "nowLang": _vm.nowLang,
      "searchBoxAlias": _vm.searchBoxAlias
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58685287!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoSearchboxCodpos.vue
// module id = 3785
// module chunks = 1